'use client';
import {
  ProductCardActionMark,
  ProductCardActionMarkIconVariant,
  productCardActionMarkIconVariants,
} from '@vs-shop/commerce-ui/productCard';
import { ProductComparisonNoticePopup } from '@vs-shop/commerce-ui/productComparisonNotice';
import { IconScale } from '@vs-shop/ui/icons';
import { Popover, PopoverAnchor } from '@vs-shop/ui/popover';
import { useState } from 'react';
import { useIntl } from 'react-intl';

import { useIsProductInComparison } from '../../../../hook/useIsProductInComparison';

import ProductComparisonPopoverContent from '../../page/product/panel/comparison/ProductComparisonPopoverContent';

import {
  addProductCodeAtom,
  removeProductCodeAtom,
} from '@vs-shop/engine/atom/productsComparison/productsComparison';
import { useAtomSet } from '@effect/atom-react';

type Props = {
  productCode: string;
};

export default function ProductCardComparisonButton({ productCode }: Props) {
  const [open, setOpen] = useState(false);

  const intl = useIntl();

  const addToComparison = useAtomSet(addProductCodeAtom);
  const removeFromComparison = useAtomSet(removeProductCodeAtom);
  const isInComparison = useIsProductInComparison(productCode);

  const handleToggleComparison = () => {
    if (isInComparison) {
      removeFromComparison(productCode);
    } else {
      addToComparison(productCode);
      setOpen(true);
    }
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverAnchor>
        <ProductCardActionMark
          onClick={handleToggleComparison}
          type="button"
          aria-label={intl.formatMessage({
            id: 'productCardComparisonButton.comparison',
            defaultMessage: 'Porovnání',
          })}
        >
          <IconScale
            className={productCardActionMarkIconVariants({
              variant: isInComparison
                ? ProductCardActionMarkIconVariant.ACTIVE
                : ProductCardActionMarkIconVariant.IDLE,
            })}
          />
        </ProductCardActionMark>
      </PopoverAnchor>
      <ProductComparisonNoticePopup align="end">
        <ProductComparisonPopoverContent
          onCloseAction={() => {
            setOpen(false);
          }}
        />
      </ProductComparisonNoticePopup>
    </Popover>
  );
}
